export default __webpack_public_path__ + "static/media/craon23.16ef02f3.jpg";